<footer class="footer_part">
    <div class="container">
        <div class="row">
            <div class="col-sm-6 col-lg-4">
                <div class="single_footer_part">
                    <a href="javascript:void(0)" class="footer_logo"> <img
                        [src]="helper.adminSettings?.logoImage ? helper.imageUrl + helper.adminSettings?.logoImage : helper.DEFAULT_LOGO" alt="#"> </a>
                    <p class="text-justify text-theme ms-1 fs-18">{{'label-title.about-us-para' | translate}} </p>
                </div>
            </div>
            <div class="col-sm-6 col-lg-4">
                <div class="single_footer_part contact_info">
                    <h4>{{'label-title.contact-info' | translate}}</h4>
                    <p>{{'label-title.address' | translate}} : {{ companyAddress }}</p>
                    @for (contact of companyContacts; track $index) {
                      <p>
                        {{ contact.name }} :
                        <a class="d-inline-block" [href]="'tel:' + contact.phone">
                          {{ contact.phone }}
                        </a>
                      </p>
                    }
                    <p>{{'label-title.email' | translate}} :
                        <a class="d-inline-block" [href]="'mailto:' + companyEmail">
                            {{ companyEmail }}
                          </a>
                        </p>
                </div>
            </div>
            <div class="col-sm-6 col-lg-4">
                <div class="single_footer_part langdiv">
                    <h4>{{'menu.language' | translate}}</h4>
                    <ul class="list-unstyled">
                        @for (language of languages; track $index) {
                        <li><a href="javascript:void(0)" (click)="onLanguageChange(language)" [ngClass]="{ active: currentLanguage === language.code }">{{language.label | translate}}</a></li>
                        }
                    </ul>
                </div>
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-sm-6 col-lg-6">
                <div class="copyright_text">
                    <p>
                        {{
                            'label-title.copyright' | translate : { _YEAR: today.getFullYear() }
                        }}
                    </p>
                </div>
            </div>
            <div class="col-sm-6 col-lg-6">
                <div class="footer_icon">
                    <h4 class="mb-3">{{'label-title.follow-us' | translate}}</h4>
                    <ul class="list-unstyled">
                        <!-- <li>
                            <a [href]="'helper.adminSettings?.facebook" target="_blank" class="single_social_icon">
                                <i class="fab fa-facebook-f"></i>
                            </a>
                        </li> -->
                        <li>
                            <a [href]="'https://www.instagram.com/kb_imitation'" target="_blank" class="single_social_icon">
                                <i class="fab fa-instagram" style="font-size: 28px;"></i>
                            </a>
                        </li>
                        <li>
                            <a [href]="'https://wa.me/918469597893'" target="_blank" class="single_social_icon">
                                <i class="fab fa-whatsapp" style="font-size: 28px;"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</footer>
